// Auto-generated from Google Doc — do not edit by hand
export const btsCaptions = {
  1: "Made In Heaven S1 - 2017",
  2: "Me, Sally White | Made In Heaven S1 - 2017",
  3: "Made In Heaven S1 - 2017",
  4: "Made In Heaven S1 - 2017",
  5: "Made In Heaven S1 - 2017",
  6: "Made In Heaven S1 - 2017",
  7: "Made In Heaven S1 - 2017",
  8: "Made In Heaven S1 - 2017",
  9: "Made In Heaven S1 - 2017",
  10: "Made In Heaven S1 - 2017",
  11: "Made In Heaven S1 - 2017",
  12: "Made In Heaven S1 - 2017",
  13: "Sally White | Made In Heaven S1 - 2017",
  14: "Made In Heaven S1 - 2017",
  15: "Made In Heaven S1 - 2017",
  16: "Made In Heaven S1 - 2017",
  17: "Made In Heaven S1 - 2017Made In  Heaven S1 - 2017",
  18: "Made In Heaven S1 - 2017",
  19: "Made In Heaven S1 - 2017",
  20: "Day 100 | Made In Heaven S1 - 2017",
  21: "Sally White, me, Zoya Akhtar | Made In Heaven S1 - 2017",
  22: "Made In Heaven S1 - 2017",
  23: "Made In Heaven S1 - 2017",
  24: "Made In Heaven S1 - 2017",
  25: "Made In Heaven S1 - 2017",
  26: "Made In Heaven S1 - 2017",
  27: "Made In Heaven S1 - 2017",
  28: "Made In Heaven S1 - 2017",
  29: "Made In Heaven S1 - 2017",
  30: "Made In Heaven S1 Poster Shoot - 2017",
  31: "Surprise guest on set | Made In Heaven S1 Poster Shoot - 2017",
  32: "Club Factory - commercial 2018",
  33: "Club Factory - commercial 2018",
  34: "Club Factory - commercial 2018",
  35: "Club Factory - commercial 2018",
  36: "Club Factory - commercial 2018",
  37: "Club Factory - commercial 2018",
  38: "Club Factory - commercial 2018",
  39: "Patrick Graham, Director | Ghoul - 2018",
  40: "DKAWCS 2018",
  41: "DKAWCS 2018",
  42: "DKAWCS 2018",
  43: "DKAWCS 2018",
  44: "DKAWCS 2018",
  45: "DKAWCS 2018",
  46: "DKAWCS 2018",
  47: "Me, Chhavi Mongia | DKAWCS 2018",
  48: "DKAWCS 2018",
  49: "DKAWCS 2018",
  50: "DKAWCS 2018",
  51: "DKAWCS 2018",
  52: "Shera Bibi set that never made it to the edit | DKAWCS 2018",
  53: "DKAWCS 2018",
  54: "DKAWCS 2018",
  55: "DKAWCS 2018",
  56: "DKAWCS 2018",
  57: "Shera Bibi set that never made it to the edit | DKAWCS 2018",
  58: "DKAWCS 2018",
  59: "DKAWCS 2018",
  60: "DKAWCS 2018",
  61: "DKAWCS 2018",
  62: "DKAWCS 2018",
  63: "DKAWCS 2018",
  64: "DKAWCS 2018",
  65: "DKAWCS 2018",
  66: "DKAWCS 2018",
  67: "DKAWCS 2018",
  68: "DKAWCS 2018",
  69: "Alankrita Srivastava, Tiya Tejpal | DKAWCS 2018",
  70: "Alankrita Srivastava, Tiya Tejpal | DKAWCS 2018",
  71: "Shera Bibi set that never made it to the edit | DKAWCS 2018",
  72: "Shera Bibi set that never made it to the edit | DKAWCS 2018",
  73: "Shera Bibi set that never made it to the edit | DKAWCS 2018",
  74: "Commercial - 2018",
  75: "Commercial - 2018",
  76: "Commercial - 2018",
  77: "Commercial - 2018",
  78: "Commercial - 2018",
  79: "Commercial - 2018",
  80: "Commercial - 2018",
  81: "Commercial - 2018",
  82: "Commercial - 2018",
  83: "Commercial for Maggie - 2018",
  84: "Commercial  - 2018",
  85: "Commercial for Maggie - 2018",
  86: "Commercial for Maggie- 2018",
  87: "Commercial for Maggie- 2018",
  88: "Commercial for Wakefit- 2018",
  89: "Commercial for Wakefit- 2018",
  90: "Pataal Lok S1 - 2019",
  91: "Mukund Gupta | Pataal Lok S1 - 2019",
  92: "Ghost Stories Zoya Akhtar - 2019",
  93: "Ghost Stories Zoya Akhtar - 2019",
  94: "Sally White, Jay Oza | Ghost Stories Zoya Akhtar - 2019",
  95: "Teji, Ananya Rane, Mohit Silswal, Yashika Gor, me | The White Tiger - 2019",
  96: "The White Tiger - 2019",
  97: "The White Tiger - 2019",
  98: "The White Tiger - 2019",
  99: "The White Tiger - 2019",
  100: "Manoj Kumar | The White Tiger - 2019",
  101: "The White Tiger - 2019",
  102: "The White Tiger - 2019",
  103: "The White Tiger - 2019",
  104: "The White Tiger - 2019",
  105: "Sunil Rodrigues, me | The White Tiger - 2019",
  106: "Tigresses ft. Arjun Mathur | The White Tiger - 2019",
  107: "Art for H&amp;M - 2019",
  108: "Art for H&amp;M - 2019",
  109: "Art for H&amp;M - 2019",
  110: "Art for H&amp;M - 2019",
  111: "Music Video: Na Nai Sunna Jigar Saraiya - 2020",
  112: "Music Video: Na Nai Sunna Jigar Saraiya - 2020",
  113: "Arjun Mathur, me | Made in Heaven S2 :  2020-2021",
  114: "Made in Heaven S2 :  2020-2021",
  115: "Made in Heaven S2 :  2020-2021",
  116: "Made in Heaven S2 :  2020-2021",
  117: "Made in Heaven S2 :  2020-2021",
  118: "Made in Heaven S2 :  2020-2021",
  119: "Made in Heaven S2 :  2020-2021",
  120: "Made in Heaven S2 :  2020-2021",
  121: "Made in Heaven S2 :  2020-2021",
  122: "Made in Heaven S2 :  2020-2021",
  123: "Made in Heaven S2 :  2020-2021",
  124: "Sid Tikolani,me | Made in Heaven S2 :  2020-2021",
  125: "Made in Heaven S2 :  2020-2021",
  126: "Thomas Reynecke | Made in Heaven S2 :  2020-2021",
  127: "Made in Heaven S2 :  2020-2021",
  128: "Made in Heaven S2 :  2020-2021",
  129: "Made in Heaven S2 :  2020-2021",
  130: "Made in Heaven S2 :  2020-2021",
  131: "Made in Heaven S2 :  2020-2021",
  132: "Made in Heaven S2 :  2020-2021",
  133: "Made in Heaven S2 :  2020-2021",
  134: "Made in Heaven S2 :  2020-2021",
  135: "Kavish Handa | Made in Heaven S2 :  2020-2021",
  136: "Made in Heaven S2 :  2020-2021",
  137: "Made in Heaven S2 :  2020-2021",
  138: "Ishwer Thakur |  Made in Heaven S2 :  2020-2021",
  139: "Made in Heaven S2 :  2020-2021",
  140: "Made in Heaven S2 :  2020-2021",
  141: "Kishu Da | Made in Heaven S2 :  2020-2021",
  142: "Made in Heaven S2 :  2020-2021",
  143: "Made in Heaven S2 :  2020-2021",
  144: "Made in Heaven S2 :  2020-2021",
  145: "Made in Heaven S2 :  2020-2021",
  146: "Made in Heaven S2 :  2020-2021",
  147: "Made in Heaven S2 :  2020-2021",
  148: "Made in Heaven S2 :  2020-2021",
  149: "Made in Heaven S2 :  2020-2021",
  150: "Made in Heaven S2 :  2020-2021",
  151: "Made in Heaven S2 :  2020-2021",
  152: "Made in Heaven S2 :  2020-2021",
  153: "Freezing in France | Made in Heaven S2 :  2020-2021",
  154: "Made in Heaven S2 :  2020-2021",
  155: "Made in Heaven S2 :  2020-2021",
  156: "Made in Heaven S2 :  2020-2021",
  157: "Made in Heaven S2 :  2020-2021",
  158: "Muksan Drama Malhotra | Made in Heaven S2 :  2020-2021",
  159: "Hardik Khanna | Made in Heaven S2 :  2020-2021",
  160: "Made in Heaven S2 :  2020-2021",
  161: "Made in Heaven S2 :  2020-2021",
  162: "Manoj Kumar | Made in Heaven S2 :  2020-2021",
  163: "Made in Heaven S2 :  2020-2021",
  164: "Made in Heaven S2 :  2020-2021",
  165: "Made in Heaven S2 :  2020-2021",
  166: "Tanay Satam | Kho gaye hum kahan : 2022",
  167: "Kho gaye hum kahan : 2022",
  168: "Kho gaye hum kahan : 2022",
  169: "Kho gaye hum kahan : 2022",
  170: "Kho gaye hum kahan : 2022",
  171: "Kho gaye hum kahan : 2022",
  172: "Me, Tanay Satam | Kho gaye hum kahan : 2022",
  173: "Kho gaye hum kahan : 2022",
  174: "Sakshi Mishra, me | Archies 2023",
  175: "Zoya Akhtar | Archies 2023",
  176: "Archies 2023",
  177: "Kripa Jain, Shravani, Dhara Jain, Shaira Kapoor, me | Archies 2023",
  178: "Commercial for Asian Paints 2024",
  179: "Commercial for Asian Paints 2024",
  180: "Commercial for Asian Paints 2024",
  181: "Commercial for Asian Paints 2024",
  182: "Commercial for Asian Paints 2024",
  183: "Commercial for Asian Paints 2024",
  184: "Commercial for Asian Paints 2024",
  185: "Commercial for OLA 2022",
  186: "Commercial for OLA 2022",
  187: "Commercial for OLA 2022",
  188: "Commercial for Amazon Pay 2024",
  189: "Commercial for Amazon Pay 2024",
  190: "Shalaka Joshi | Commercial for Amazon Pay 2024",
  191: "Commercial for Amazon Pay 2024",
  192: "Commercial for Amazon Pay 2024",
  193: "Commercial for Amazon Pay 2024",
  194: "Commercial for Amazon Pay 2024",
  195: "Commercial for Amazon Pay 2024",
  196: "Commercial for Amazon Pay 2024",
  197: "Commercial for Carate Lane 2024",
  198: "Music Video : Farahmoosh Madboy Mink 2024",
  199: "Music Video : Farahmoosh Madboy Mink 2024",
  200: "Music Video : Farahmoosh Madboy Mink 2024",
  201: "Commercial for Samco 2024",
  202: "Commercial for Samco 2024",
  203: "Commercial for Samco 2024",
  204: "Commercial for Samco 2024",
  205: "Chhavi Mongia | Commercial for Godrej 2024",
  206: "Commercial for Horlick 2024",
  207: "Commercial for Jiomart 2024",
  208: "Commercial for Jiomart 2024",
  209: "Commercial for Jiomart 2024",
  210: "Commercial for Jiomart 2024",
  211: "Commercial for Jiomart 2024",
  212: "Commercial for Jiomart 2024",
  213: "Commercial for Jiomart 2024",
  214: "Commercial for Jiomart 2024",
  215: "Commercial for Jiomart 2024",
  216: "Commercial for Jiomart 2024",
  217: "Commercial for Jiomart 2024",
  218: "Commercial for Jiomart 2024",
  219: "Commercial for Jiomart 2024",
  220: "Aashka Thakker | Commercial for Jiomart 2024",
  221: "Commercial for Jiomart 2024",
  222: "Commercial for Jiomart 2024",
  223: "Commercial for Jiomart 2024",
  224: "Commercial for Jiomart 2024",
  225: "Commercial for Jiomart 2024",
  226: "Commercial for Jiomart 2024",
  227: "Commercial for Jiomart 2024",
  228: "Commercial for Jiomart 2024",
  229: "Commercial for Jiomart 2024",
  230: "Commercial for Jiomart 2024",
  231: "Commercial for Jiomart 2024",
  232: "Commercial for Jiomart 2024",
  233: "Commercial for Jiomart 2024",
  234: "Commercial for Jiomart 2024",
  235: "Naseeruddin Shah, me | Short Film : MWWM Naseeruddinn Shah 2024",
  236: "Naseeruddin Shah | Short Film : MWWM Naseeruddinn Shah 2024",
  237: "Anil Mehta, Yakoub Pathan | MWWM Naseeruddinn Shah 2024",
  238: "Tiya Tejpal, Ratna Pathak Shah | Short film : MWWM Naseeruddinn Shah 2024",
  239: "Short Film : Panha 2024",
  240: "Short Film : Panha 2024",
  241: "Short Film : Panha 2024",
  242: "Commercial for Crompton 2024",
  243: "Commercial for Crompton 2024",
  244: "Me, Vrushti Kothi, Paarth AKA Pappukaana | Short Film : Control + Esc 2024",
  245: "Short Film : Control + Esc 2024",
  246: "Paarth AKA Pappukaana | Short Film : Control + Esc 2024",
  247: "Short Film : Control + Esc 2024",
  248: "Business of Fashion 2024",
  249: "Business of Fashion 2024",
  250: "Business of Fashion 2024",
  251: "Dinner at Aamir Khan’s house 2024 before Loveyapa",
  252: "Short Film : Samir Zaidi 2024",
  253: "Loveyapa 2024",
  254: "Loveyapa 2024",
  255: "Loveyapa 2024",
  256: "Loveyapa 2024",
  257: "Chhavi Mongia, me, Aashka Thakker,  Muskan Malhotra, Sanjana Deshmukh, Fizaa Lamba | Loveyapa 2024",
  258: "Loveyapa 2024",
  259: "Loveyapa 2024",
  260: "Loveyapa 2024",
  261: "Loveyapa 2024",
  262: "Loveyapa 2024",
  263: "Loveyapa 2024",
  264: "Loveyapa 2024",
  265: "Loveyapa 2024",
  266: "Loveyapa 2024",
  267: "Loveyapa 2024",
  268: "Loveyapa 2024",
  269: "Hardik Khanna | Loveyapa 2024",
  270: "Loveyapa 2024",
  271: "Loveyapa 2024",
  272: "Loveyapa 2024",
  273: "Loveyapa 2024",
  274: "Loveyapa 2024",
  275: "Loveyapa 2024",
  276: "Rohan Mestry, Musan Malhotra, Fizaa Lamba, Aashka Thakker, Chhavi Mogia Loveyapa 2024",
  277: "Loveyapa 2024",
  278: "Loveyapa 2024",
  279: "Loveyapa 2024",
  280: "Loveyapa 2024",
  281: "Loveyapa 2024",
  282: "Loveyapa 2024",
  283: "Loveyapa 2024",
  284: "Loveyapa 2024",
  285: "Loveyapa 2024",
  286: "Loveyapa 2024",
  287: "Loveyapa 2024",
  288: "Loveyapa 2024",
  289: "Loveyapa 2024",
  290: "Me, Advait Chadan | Loveyapa 2024",
  291: "Loveyapa 202",
  292: "Loveyapa 2024",
  293: "Loveyapa 2024",
  294: "Loveyapa 2024",
  295: "Loveyapa 2024",
  296: "Loveyapa 2024",
  297: "Loveyapa 2024",
  298: "Loveyapa 2024",
  299: "Loveyapa 2024",
  300: "Loveyapa 2024",
  301: "Loveyapa 2024",
  302: "",
  303: "Loveyapa 2024",
  304: "Loveyapa 2024",
  305: "Loveyapa 2024",
  306: "Loveyapa 2024",
  307: "Loveyapa 2024",
  308: "Loveyapa 2024",
  309: "Loveyapa 2024",
  310: "Loveyapa 2024",
  311: "Loveyapa 2024",
  312: "Loveyapa 2024",
};
export const BTS_PHOTO_COUNT = 312;